import React from 'react'
import { RiArrowRightSLine } from 'react-icons/ri'
import Header from '../../Header/header'
import './Microneedling.css'
import Whatsapp from '../../Whatsapp/Whatsapp'
import ServiceFAQ from '../ServiceFAQ'
import ServiceDoctorInfo from '../ServiceDoctorInfo'
import doc_img from '../../../assets/doc_img.webp'

const microneedlingFAQs = [
  {
    question: 'How many microneedling sessions will I need?',
    answer: 'Most patients need 4 to 6 sessions spaced 3 to 4 weeks apart to see meaningful improvement in texture, scars, or fine lines.',
  },
  {
    question: 'Is microneedling painful?',
    answer: 'A numbing cream is applied before the procedure, so most patients feel only mild discomfort during treatment.',
  },
  {
    question: 'What is the downtime after microneedling?',
    answer: 'You may experience redness similar to a mild sunburn for 1 to 3 days, after which normal skincare and makeup can typically resume.',
  },
  {
    question: 'Can microneedling treat acne scars?',
    answer: "Yes, microneedling is particularly effective for rolling and shallow acne scars by stimulating the skin's natural collagen production.",
  },
]

const Microneedling = () => {
  return (
    <div className='asthmacontent'>
      <Header />
      <Whatsapp />
      <div className='asthmamain'>
        <div className='microneedlinghero'>
          <div className='asthmainner'>
            <div className='heroservice'>
              Service <RiArrowRightSLine /> Microneedling
            </div>
            <div className='heroheadline'>
              <h1 className='' style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                Best Microneedling treatment in Pitampura |Advanced Skin Rejuvenation | Sharva clinic
              </h1>
              <p className='' style={{ fontFamily: 'inherit' }}>
                Looking for the best micorneedling treatment in Pitampura? Sharva clinic offers advanced microneedling for acne scars, open pores and
                skin rejuvenation.
              </p>
            </div>
            <a href='/appoint'>
              <button className='asthmabtn'>Book Now</button>
            </a>
          </div>
        </div>

        <div className='asthmamid'>
          <div className='asthmapra'>
            <div>
              <h2 style={{ fontSize: '30px', fontWeight: 'bold' }}>Best Microneedling Treatment in Pitampura</h2>
              <p>
                Healthy, glowing skin is something everyone desires, but concerns like acne scars, uneven texture, fine lines, and enlarged pores can
                affect confidence. At <span style={{ fontWeight: 'bold' }}>Sharva Clinic</span>, we offer the{' '}
                <span style={{ fontWeight: 'bold' }}>best microneedling treatment in Pitampura</span>, designed to naturally stimulate skin repair and
                restore smoother, youthful-looking skin.
              </p>
              <p>
                Microneedling is a modern dermatological procedure that activates the skin&apos;s own healing process. Using advanced technology and
                precise techniques, our specialists help improve skin texture, reduce scars, and promote collagen production for long-lasting results.
              </p>
              <p>
                Our clinic focuses on safe, customised treatments so that every patient receives a solution suited to their specific skin concerns.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>What is Microneedling Treatment?</h3>
              <p>
                Microneedling is a minimally invasive skin rejuvenation procedure that uses very fine sterile needles to create controlled
                micro-channels in the skin. These tiny channels stimulate the body&apos;s natural healing response, encouraging the production of
                collagen and elastin.
              </p>
              <p>
                This process helps repair damaged skin and improves overall skin quality. Over time, the skin becomes smoother, firmer, and more even
                in tone.
              </p>
              <p>
                The procedure is widely recommended for people who want visible skin improvement without undergoing aggressive treatments or surgery.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Benefits of Microneedling</h3>
              <p>
                Choosing the <span style={{ fontWeight: 'bold' }}>best microneedling treatment in Pitampura</span> can offer several skin benefits,
                including:
              </p>
              <ul>
                <li>Reduction of acne scars and marks</li>
                <li>Improvement in skin texture and tone</li>
                <li>Minimising enlarged pores</li>
                <li>Reduction of fine lines and early signs of ageing</li>
                <li>Better absorption of skin-boosting serums</li>
                <li>Enhanced natural collagen production</li>
                <li>Brighter and healthier looking skin</li>
              </ul>
              <p>The treatment works gradually, allowing the skin to rebuild itself naturally.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Skin Concerns Treated with Microneedling</h3>
              <p>Microneedling is a versatile treatment that can help improve multiple skin issues, such as:</p>
              <ul>
                <li>Acne scars</li>
                <li>Open pores</li>
                <li>Uneven skin texture</li>
                <li>Mild pigmentation</li>
                <li>Fine lines and wrinkles</li>
                <li>Dull or tired-looking skin</li>
                <li>Stretch marks in some cases</li>
              </ul>
              <p>At Sharva Clinic, the treatment plan is customised according to your skin type and specific concerns.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Microneedling Procedure at Sharva Clinic</h3>
              <p>Our approach focuses on safety, precision, and patient comfort.</p>

              <p>
                <span style={{ fontWeight: 'bold' }}>1. Skin Assessment</span>
                <br />
                The process begins with a detailed skin evaluation to understand your concerns and suitability for microneedling.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>2. Preparation</span>
                <br />
                The skin is cleansed and a topical numbing cream may be applied to ensure comfort during the procedure.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>3. Microneedling Treatment</span>
                <br />A specialised device with fine needles is gently moved across the skin to create micro-channels.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>4. Skin Nourishment</span>
                <br />
                Skin-repairing serums are applied to enhance healing and boost results.
              </p>

              <p>
                <span style={{ fontWeight: 'bold' }}>5. Post-Treatment Care</span>
                <br />
                You receive detailed aftercare instructions to help your skin recover smoothly.
              </p>

              <p>The entire procedure typically takes around 30–45 minutes depending on the treatment area.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Why Choose Sharva Clinic for Microneedling in Pitampura?</h3>
              <p>Sharva Clinic is known for providing advanced aesthetic treatments with a focus on safety and natural-looking results.</p>
              <p>Reasons patients choose us include:</p>
              <ul>
                <li>Experienced cosmetic specialists</li>
                <li>Advanced skin treatment technology</li>
                <li>Personalised treatment plans</li>
                <li>Hygienic and safe clinical environment</li>
                <li>Focus on natural skin rejuvenation</li>
                <li>Detailed pre and post treatment guidance</li>
              </ul>
              <p>Our goal is to deliver visible improvements while maintaining the health and integrity of your skin.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Who Can Benefit from Microneedling?</h3>
              <p>
                Microneedling is suitable for individuals who want to improve skin quality without invasive procedures. It may be recommended for
                people experiencing acne scars, early ageing signs, uneven texture, or enlarged pores.
              </p>
              <p>A proper consultation helps determine whether the treatment is appropriate for your skin type and goals.</p>
            </div>

            <div>
              <h3 style={{ fontSize: '23px' }}>Book the best microneedling treatment in Pitampura</h3>
              <p>
                If you are looking for a reliable solution to improve skin texture and reduce scars, sharva clinic offers the best microneedling
                treatment in Pitampura with advanced techniques and personalized care.
              </p>
            </div>

            <ServiceDoctorInfo
              name='Dr. Sweta Mishra'
              specialty='Maxillofacial Aesthetic Surgeon'
              education='MDS, FAM, Dip. in Aesthetic Medicine'
              image={doc_img}
              blurb='Dr. Sweta Mishra performs microneedling at Sharva Clinique to improve skin texture, acne scars, and overall skin quality using advanced techniques.'
              profileLink='/drSweta/micro'
            />

            <ServiceFAQ title='FAQs - Microneedling Treatment' faqs={microneedlingFAQs} />
          </div>

          <div className='asthmareview'>
            <p
              style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#85553D',
                fontFamily: 'inherit',
              }}
            >
              What Our Patients Say
            </p>

            <div className='card1'>
              <p>
                “Perfect treatment for dull skin.” My complexion looks brighter and smoother. Even my friends noticed the difference within a few
                weeks.
              </p>
              <p> — Shalini </p>
            </div>

            <div className='card2'>
              <p>
                “Noticeable improvement in fine lines.” I was worried about aging signs, but microneedling really helped improve firmness around my
                cheeks and forehead.
              </p>
              <p> — Ritika </p>
            </div>

            <div className='card3'>
              <p>
                “Great experience from start to finish.” Friendly staff, clean environment, and visible improvement in my skin texture after just one
                session.
              </p>
              <p> — Meenal </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Microneedling
